import axios from 'axios';
import config from '../config';
import {
  isProviderArea,
  clearProviderSession,
  clearClientSession,
} from './session';
import { trackRequests } from './requestActivity';

// A sessao e um cookie HttpOnly: o navegador so o envia com withCredentials.
// O header fixo e a defesa CSRF exigida pela API em toda requisicao que nao seja GET/HEAD/OPTIONS.
export const CSRF_HEADER = { 'x-requested-with': 'sobre-rodas' };
const sessionOptions = { withCredentials: true, headers: CSRF_HEADER };

//api = conteudo legado que insere manualmente o enpoint devido o erro de escrita baseUrl para baseURL
const api = axios.create({ baseUrl: config.endpoint, ...sessionOptions });

//apiV1 = mesmo fluxo da api, porém sem inserção do config.endpoint
const apiV1 = axios.create({
  baseURL: config.endpoint,
  responseType: 'json',
  ...sessionOptions,
});
const apiv2 = axios.create({ baseURL: config.endpointv2, ...sessionOptions });

// Paginas do prestador que recebem 401 como resposta normal (credencial errada)
const PROVIDER_PUBLIC_PATHS = [
  '/provider/login',
  '/provider/newpassword',
  '/auto-login',
];

export function handleResponseError(error) {
  const response = error && error.response;
  if (!response || response.status !== 401) {
    return Promise.reject(error);
  }

  const pathname = window.location.pathname;

  // Painel admin: sessao propria; expirou no meio do uso, volta ao login do painel.
  if (pathname === '/admin' || pathname.startsWith('/admin/')) {
    if (!pathname.startsWith('/admin/login') && !pathname.startsWith('/admin/reset-password')) {
      window.location.href = '/admin/login';
      return;
    }
    return Promise.reject(error);
  }

  if (isProviderArea(pathname)) {
    if (PROVIDER_PUBLIC_PATHS.some((path) => pathname.startsWith(path))) {
      return Promise.reject(error);
    }
    clearProviderSession();
    window.location.href = '/provider/login';
    return;
  }

  // Fora da area do cliente (home, busca, detalhe da empresa) um 401 nao e sessao
  // expirada: so rejeita e a tela trata, em vez de jogar o visitante no login.
  if (!pathname.startsWith('/client')) {
    return Promise.reject(error);
  }

  const message = response.data && response.data.message;
  if (message === 'token not provided' || message === 'invalid token') {
    clearClientSession();
    window.location.href = '/client/login';
    return;
  }

  return Promise.reject(error);
}

[api, apiV1, apiv2].forEach((instance) => {
  trackRequests(instance);
  instance.interceptors.response.use(
    (response) => response,
    handleResponseError,
  );
});

export default { api, apiV1, config, apiv2 };
